import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ChevronDown } from 'lucide-react';

import type { DevelopmentDetailEstimateResponse } from '@/domain/models/development.js';
import { EstimateSummary } from '@/presentation/components/index.js';
import { formatDate } from '@/shared/utils/format-date.js';

interface Props {
    estimates: DevelopmentDetailEstimateResponse[];
    historyLabel: string;
    versionLabel: string;
    rejectedLabel: string;
}

export function EstimateHistoryAccordion({ estimates, historyLabel, versionLabel, rejectedLabel }: Props) {
    return (
        <Accordion variant="outlined" disableGutters data-testid="estimate-history-accordion">
            <AccordionSummary expandIcon={<ChevronDown size={18} />}>
                <Typography variant="subtitle2" fontWeight={600}>
                    {historyLabel} ({estimates.length})
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack divider={<Divider />} spacing={1.5}>
                    {[...estimates]
                        .sort((a, b) => b.version - a.version)
                        .map((estimate) => (
                            <Box key={estimate.id}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                                    <Typography variant="body2" fontWeight={600}>
                                        {versionLabel} {estimate.version}
                                        {estimate.rejected && ` · ${rejectedLabel}`}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {formatDate(estimate.createdAt)}
                                    </Typography>
                                </Stack>
                                <EstimateSummary complexity={estimate.complexity} estimatedHours={estimate.estimatedHours} estimatedDeliveryDate={estimate.estimatedDeliveryDate} />
                            </Box>
                        ))}
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}
